import { UseFormReturn } from 'react-hook-form';

import { SupportServiceCategory } from './supportServiceCategory';
import { SupportServiceTag } from './supportServiceTag';
import { TenantUser } from './tenantUser';

export type SupportService = {
  id: number;
  published_at: string;
  tenant_user: TenantUser;
  support_service_category: SupportServiceCategory;
  support_service_tags: SupportServiceTag[];
  title: string;
  description: string;
  content: string;
  thumbnail_url: string;
  status: number;
  status_text: string;
  is_top_display: boolean;
};

export type SupportServiceForm = {
  title: string;
  published_at: string | null;
  support_service_category_id: number | null;
  support_service_category?: SupportServiceCategory;
  support_service_tags: number[] | SupportServiceTag[];
  support_service_tags_name?: string[];
  description: string;
  thumbnail_url: string | null;
  content: string;
  status?: number;
  is_top_display: boolean;
};

export interface SupportServiceFormErrors {
  [field: string]: string[];
}

export type SupportServiceFormProps = {
  categoryOptions: SupportServiceCategory[];
  availableTags: SupportServiceTag[];
  setAvailableTags: (tags: SupportServiceTag[]) => void;
  errors?: SupportServiceFormErrors;
  setErrors?: (errors: SupportServiceFormErrors) => void;
  methods: UseFormReturn<SupportServiceForm>;
};

export const supportServiceDefaultFormState: SupportServiceForm = {
  title: '',
  published_at: null,
  support_service_category_id: null,
  support_service_tags: [],
  description: '',
  thumbnail_url: null,
  content: '',
  is_top_display: false,
};

export const FORM_CONSTANTS = {
  MAX_TITLE_LENGTH: 150,
  MAX_DESCRIPTION_LENGTH: 140,
  MAX_TAGS: 10,
} as const;
